<template>
  <div class="hostDialog">
    <el-dialog
      :visible.sync="status"
      width="30%"
      title="编辑从机"
      :close-on-click-modal="false"
    >
      <div class="dialog__main">
        <p><img src="../img/dialogAddIcon.png" />{{ title }}</p>
        <el-form :model="form" ref="form" class="form" :rule="rules">
          <el-form-item
            label="设备名称"

            prop="terminalName"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.terminalName"      :disabled="islook"></el-input>
          </el-form-item>
          <el-form-item
            label=""
            prop="terminalName"
            :label-width="formLabelWidth"
          >
            <el-checkbox v-model="checked">同步名称至对应监测点</el-checkbox>
          </el-form-item>
          <el-form-item

            label="设备imel"
            prop="imei"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.imei"    :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="通信地址" prop="addr485"     :label-width="formLabelWidth">
            <el-select size="large" v-model="form.addr485"      :disabled="islook" placeholder="请选择通信地址">
              <el-option
                v-for="item in ableaddrList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>

            </el-select>

          </el-form-item>
          <el-form-item
            label="启停"
            prop="enableStatus"
            :label-width="formLabelWidth"
          >
            <el-switch
              :disabled="islook"
              v-model="form.enableStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              size="large"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="物联网卡号"-->
<!--            prop="sim"-->
<!--            :label-width="formLabelWidth"-->
<!--          >-->
<!--            <el-input v-model="form.sim" size="large"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="备注"
            prop="remark"
            :label-width="formLabelWidth"
          >
            <el-input
              :disabled="islook"
              v-model="form.remark"
              type="textarea"
              size="large"
            ></el-input>
          </el-form-item>

          <el-form-item label="照片上传"  :label-width="formLabelWidth">
            <el-upload
              :disabled="islook"
              class="upload-img"
              name="file"
              :headers="headers"
              :action="uploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              list-type="picture-card"
              :on-exceed="handleExceed"
              :on-success="imgsucc"
              :file-list="fileList"
            >
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
              </span>
              <!--                <el-button size="small" type="primary">点击上传</el-button>-->
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer" v-show="!islook">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="status = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="图片" :close-on-click-modal="false" :visible.sync="showbigimg" width="550px">

      <img :src=bigimgurl alt="">
    </el-dialog>
  </div>
</template>

<script>
import Axios from "../../../../utils/Axios";
export default {
  name: "hostDialog",
  props: {},
  data() {
    return {
      status: false,
      checked: true,
      title: "",
      rules: {
        imei: [{ required: true, message: "请输入imei", trigger: "blur" }],
        enableStatus: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
      },
      form: {
        terminalId:"",
        addr:"",
        imei:"",
        enableStatus:"",
        terminalName:"",
        remark:"",
      },
      fileList:[],
      deptNameList: null,
      treelist:[],
      checkurl:[],
      showbigimg: false,
      islook: false,
      bigimgurl: "",
      deptList: [],
      ableaddrList: [],
      hostTerminalId:"",
      formLabelWidth: "90px",

    };
  },
  computed: {
    uploadUrl() {
      return this.baseUrl + "device/uploadPicture";
    },
    headers() {
      return {
        authorization:sessionStorage.getItem("token"),
      };
    },
  },
  methods: {
    getcongaddr(id){
      //获取地址列表
      let that = this;
      let param = {};
      param.method="post";
      param.url="/device/findAvlAddr485";
      param.data={
        terminalId:id
      }
      Axios.ajax(param).then((res)=>{

        if(res.data){

          that.ableaddrList=[]
          for(let i=0;i<res.data.length;i++){
            that.ableaddrList.push({label:res.data[i],value:res.data[i]})
          }

        }

      })
    },
    changelabelToid(label){
      for(let i=0;i<this.treelist.length;i++){
        if(this.treelist[i].label==label){
          return this.treelist[i].value
        }
      }
    },
    cleardata(){
      this.form={
        deptId: 1,
        enableStatus: 1,
        imei: "",
        picturePaths: [],
        remark: "",
        sim: null,
        terminalName: "",
        showbigimg: false,
        fileList: [],
        addr485:""
      }
      this.deptNameList=[]
      this.checkurl=[]
    },
    confirm() {
      let that=this

      this.$refs.form.validate((va) => {

        let picturePaths=[]
        for(let i=0;i<this.checkurl.length;i++){
          if(this.checkurl[i].path){
            picturePaths.push(this.checkurl[i].path)
          }else{
            picturePaths.push(this.checkurl[i].response.data.picturePath)
          }

        }
        Axios.ajax({
          url: "/device/modify",
          method: "post",
          data:{
            terminalId:this.outdata.terminalId,
            addr:this.form.addr485,
            imei:this.form.imei,
            enableStatus:this.form.enableStatus,
            terminalName:this.form.terminalName,
            remark:this.form.remark,
            picturePaths:picturePaths,
            syncMonitorName:this.checked,

          },
        }).then((res) => {
          if(res.resultCode=='0'){
            that.$message({
              type: 'success',
              message:"修改成功"
            });
            this.status=false
            this.queryDepList()
            this.$emit("gettabledata", true)
          }else{
            that.$message({
              type: 'error',
              message: res.resultMessage
            });
          }
        });
      });
    },
    controlDialog(str,data,bool,deplist) {
      let that=this
      this.deptList =deplist;
      this.status = true;
      this.title = str;
      this.cleardata()
      this.outdata=data
      this.islook=bool
      that.getdata()
      this.getcongaddr(data.terminalId)

    },
    getdata(){
      this.form.imei=this.outdata.imei
      this.form.addr485=this.outdata.addr485.substring(this.outdata.addr485.length-2)

      this.form.enableStatus=this.outdata.enableStatus
      this.form.terminalName=this.outdata.terminalName
      this.deptNameList=this.outdata.deptName
      this.getsbdetailMessage(this.outdata.terminalId)
    },
    getsbdetailMessage(terminalId){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/device/getTerminalDetail";
      param.data={
        terminalId:terminalId
      }

      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          that.fileList=[]
          that.form.remark=res.data.remark
          for(let i=0;i<res.data.pictures.length;i++){
            that.fileList.push({url:res.data.pictures[i].pictureUrl,path:res.data.pictures[i].picturePath})
            that.checkurl.push({url:res.data.pictures[i].pictureUrl,path:res.data.pictures[i].picturePath})
          }

        }else{

        }

      })
    },

    handlePreview(file) {
      //点击放大镜触发
      this.showbigimg = true;
      console.log(file)
      if (file.path) {
        this.bigimgurl = file.url;
      } else {
        this.bigimgurl = file.response.data.pictureUrl;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm("ok");
    },
    imgsucc(val, file, fileList) {
      this.checkurl = fileList;
    },
    handleRemove(file, fileList) {
      this.checkurl = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
  mounted() {

    },
  created() {

  },
  watch:{
    status(){
      this.checked=true
      if(this.status==false){
        this.checkurl=[]
        this.fileList=[]
      }
    },
  }
};
</script>

<style lang="less" scoped>
.hostDialog {
  .dialog__main {
    p {
      margin: 0 0 10px 20px;
      height: 30px;
      line-height: 10px;
      img {
        margin-right: 12px;
      }
    }
  }
}
</style>
